module.exports = __webpack_public_path__ + "static/media/MIA_animation.15f10777.svg";